import * as types from "../actions/types/transaction.types";
import { capitalize, convertToDateFromDDMMYYYY } from "../../utils/utilityFunctions";

const initialState = {
    transactionList: [],
    filter: {},
};

export const transactionHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_TRANSACTIONS_HISTORY_FILTER:
            return {
                ...state,
                filter: action.payload,
            };

        case types.FETCH_TRANSACTIONS_HISTORY_SUCCEEDED:
            const transactionTags = JSON.parse(localStorage.getItem("transactionTags"));
            const electricityTagsId = transactionTags
                .filter(({ tagName }) => tagName.includes("Electricity"))
                .map(({ tagId }) => parseInt(tagId));

            const tl =
                [...action.payload]?.map((t) => {
                    const transactionType = t.partTranType?.toLowerCase();
                    const isDebit = transactionType === "d";
                    const isCredit = transactionType === "c";

                    const newDate = convertToDateFromDDMMYYYY(t.postedDate);

                    const amount = isCredit
                        ? t.credit - t.charge
                        : isDebit
                        ? t.debit - t.charge
                        : 0;

                    const name = electricityTagsId?.includes(t.tagId)
                        ? capitalize(t.tranParticular)
                        : t.name;

                    return {
                        ...t,
                        name,
                        tranAmount: amount,
                        total: amount,
                        postedDate: newDate,
                        tranDate: newDate,
                        valueDate: newDate,
                    };
                }) || [];

            return {
                ...state,
                transactionList: tl,
            };

        case types.FETCH_TRANSACTIONS_HISTORY_FAILED:
            return {
                ...state,
                transactionList: [],
            };

        default:
            return state;
    }
};
